import React, { Component } from 'react'
import Container from '../common/application_container'
import Axios from 'axios';
import { REPORT_BALANCE, DOWNLOAD_REPORT_URL, LOGIN_URL } from '../../config/rest_endpoints';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import moment from 'moment'
import { Notifications } from '../common/notification';
import { getUser } from '../../actions/session';
import CustomLoader from '../common/loader';
import { CSVLink } from "react-csv";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import setSeconds from "date-fns/setSeconds";
import { Redirect } from 'react-router';
import { RC_LOAD_LOGIN } from '../routers/RouteConstants';

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";


var firstDate = new Date();

// subtract 1 hour from current time
const startT = moment(firstDate.setHours(firstDate.getHours() - 1))
console.log('first :>> ', startT._d);

// const startT = moment(firstDate.getTime()).subtract(1, 'h')

const todayInitialDate = moment(firstDate.setHours(0, 0, 0, 0))
const todayFinalDate = moment(firstDate.setHours(23, 59, 0, 0))

const yesterdayInitialDate = moment(todayInitialDate).subtract(1, 'd')
const yesterdayFinalDate = moment(todayFinalDate).subtract(24, 'h')




// const todayInitialDate =  moment(firstDate.setHours(0,0,0,0)).unix();
// console.log('todayIntialDate :>> ', todayInitialDate);
// const todayFinalDate = moment(firstDate.setHours(23,59,0,0)).unix();

// const yesterdayInitialDate =   moment(todayInitialDate).subtract(1, 'd').unix()
// const yesterdayFinalDate = moment(todayFinalDate).subtract(1,'d').unix();


class MainReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            data: [],
            isGetting: false,
            // startDate: setHours(setMinutes(setSeconds(new Date(), 0), 0),0),
            // endDate: setHours(setMinutes(setSeconds(new Date(), 59), 59),23),
            startDate: moment().startOf('day').toDate(), // Start at midnight (00:00 AM)
            endDate: moment().endOf('day').subtract(1, 'second').toDate(), // 
            todayStartDate: todayInitialDate._d,
            todayEndDate: todayFinalDate._d,
            isToday: false,
            yesterdayStartDate: yesterdayInitialDate._d,
            yesterdayEndDate: yesterdayFinalDate._d,
            isYesterday: false,
            downloadLink: '',
            isDownload: false,
            fileName: '',
            downloading: false,
            isLoginURL:false
        }
        this.handleDate = this.handleDate.bind(this)
        this.getBalanceReport = this.getBalanceReport.bind(this)
        // this.getTodayCalls = this.getTodayCalls.bind(this)
        this.DownloadReport = this.DownloadReport.bind(this)
        // this.getYesterdayCalls = this.getYesterdayCalls.bind(this)
        this.disabledDownload = this.disabledDownload.bind(this)
    }

    componentDidMount() {
        this.getBalanceReport()
    }

    handleDate(date, value) {
        if (value == "start") {
            this.setState({ startDate: date, isToday: false, isYesterday: false }, () => {
                console.log('start', this.state.startDate);
            })
        } else {
            this.setState({ endDate: date, isToday: false, isYesterday: false }, () => {
                console.log('end', this.state.endDate);
            })
        }
    }

    disabledDownload() {
        this.setState({ isDownload: false })
    }

    DownloadReport() {
        const { User, startDate, endDate, isToday, todayStartDate, todayEndDate, isYesterday, yesterdayStartDate, yesterdayEndDate } = this.state

        var payload = {
            // "startDate":startDate.toLocaleString(),
            // "endDate": endDate.toLocaleString()
            "startDate": moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
            "endDate": moment(endDate).format('MM/DD/YYYY, h:mm:ss A')
           
        }
        this.setState({ downloading: true })
        console.log('timeLoad :>> ', payload);
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.post(`${DOWNLOAD_REPORT_URL}`, payload, { headers }).then(res => {
            let content = res.headers['content-disposition']
            console.log('content :>> ', content);
            if (res) {

                var response = res.data;
                var short = content.substr(21)

                this.setState({
                    downloadLink: response,
                    isDownload: true,
                    fileName: short,
                    downloading: false
                })

            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({isLoginURL:true})
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    getBalanceReport() {
        const { User, startDate, endDate } = this.state
        var timeLoad = {
            // "startDate": startDate.toLocaleString(),
            // "endDate": endDate.toLocaleString()
            "startDate": moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
            "endDate": moment(endDate).format('MM/DD/YYYY, h:mm:ss A')
        }
        this.setState({ isGetting: true })
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.post(`${REPORT_BALANCE}`, timeLoad, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                this.setState({ data: resp, isGetting: false, isDownload: false })
                // Notifications.notify("Filter date fetched successfully", "Success", "success")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({isLoginURL:true})
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    // getTodayCalls() {
    //     const { User,todayStartDate,todayEndDate } = this.state
    //     var todayLoad = {
    //         "data": {
    //             "start": Math.floor(todayStartDate.getTime() / 1000.0),
    //             "end": Math.floor(todayEndDate.getTime() / 1000.0)
    //         }
    //     }

    //     this.setState({ isGetting: true, isYesterday: false})
    //    console.log('todayLoad :>> ', todayLoad);
    //     var headers = { "Authorization": "Bearer " + User.token };
    //     Axios.post(`${REPORT_BALANCE}`, todayLoad, { headers }).then(res => {
    //         if (res) {
    //             console.log('todaycall :>> ', res);
    //             var resp = res.data.data
    //             this.setState({ 
    //                 data: resp, 
    //                 isGetting:false ,
    //                 isToday:true,
    //                 isDownload:false

    //             })
    //             Notifications.notify("Today report fetched successfully", "Success", "success")
    //         }
    //     })
    // }

    // getYesterdayCalls() {
    //     const { User, yesterdayStartDate,yesterdayEndDate } = this.state

    //     var yesterdayLoad = {
    //         "data": {
    //             "start": Math.floor(yesterdayStartDate  .getTime() / 1000.0),
    //             "end": Math.floor(yesterdayEndDate.getTime() / 1000.0)
    //         }
    //     }

    //     this.setState({isGetting:true, isToday:false})
    //    console.log('yesterday :>> ', yesterdayLoad);
    //     var headers = { "Authorization": "Bearer " + User.token };
    //     Axios.post(`${REPORT_BALANCE}`, yesterdayLoad, { headers }).then(res => {
    //         if (res) {
    //             console.log('yesterdayCall :>> ', res);
    //             var resp = res.data.data
    //             this.setState({ 
    //                 data: resp , 
    //                 isGetting:false,
    //                 isYesterday:true,
    //                 isDownload:false
    //             })
    //             Notifications.notify("Yesterday report fetched successfully", "Success", "success")
    //         }
    //     })
    // }

    renderReportBalance() {
        const { data } = this.state
        console.log('data :>> ', data);
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>)
        if (data == null) {
            return nullData
        }
        else {
            return data.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.accountName}</td>
                        <td style={{textAlign:'center'}}>{row.cost}</td>
                        <td style={{textAlign:'center'}}>{row.minutes}</td>
                    </tr>
                )
            })
        }

    }

    render() {
        const { startDate, endDate, isGetting, isDownload, downloading, fileName } = this.state
        if (this.state.isLoginURL === true) {
            return <Redirect to={RC_LOAD_LOGIN} ></Redirect>
        }
        return (
            <Container title="Balence" title1="Report" icon="fa fa-bars">
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    <div className="card-header header-elements-inline p-0 py-1 mb-1">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title "></h5>
                        <div className="header-elements ml-auto">
                            <button type="button" className="main-button mb-2 ml-auto btn btn-success btn-sm " onClick={this.DownloadReport}><i class={downloading ? "fas fa-sync fa-spin mr-2" : "icon-file-plus mr-2 icon-1x"}></i>Generate Report</button>
                            {isDownload ? <CSVLink data={this.state.downloadLink} onClick={this.disabledDownload} className="ml-1" filename={fileName} ><i class="icon-download mr-2 icon-2x"></i>Download</CSVLink> : ''}
                            {/* {isDownload ? <CSVLink data={this.state.downloadLink}  className="btn bg-info "  filename={fileName} ><i class="icon-file-download mr-2 icon-1x"></i>Download Report</CSVLink>
                            :  <button type="button" className="btn bg-theme " onClick={this.DownloadReport}><i class="icon-file-plus mr-2 icon-1x"></i>Generate Report</button>} */}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2">
                        <div class=" py-2 px-3 mb-1">
                            <div class="">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Start Date<span className="text-muted "> UTC Time-zone</span> </label>
                                <div class="input-group">
                                <DateRangePicker
                                    onCallback={(date) => this.handleDate(date, "start")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    timePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(startDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY h:mm A',
                                    },
                                    }} 
                                >
                                <input  type="text" className="form-control" style={{ minWidth: '300px' }} />
                                </DateRangePicker>
                                </div>
                            </div>
                        </div>
                        <div class=" py-2 px-3 mb-1">
                            <div class="">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">End Date <span className="text-muted "> UTC Time-zone</span> </label>
                                <div class="input-group">
                                <DateRangePicker
                                    onCallback={(date) => this.handleDate(date, "end")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    timePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(endDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY h:mm A',
                                    },
                                    }}
                                >
                                <input type="text" className="form-control" style={{ minWidth: '300px' }} />
                                </DateRangePicker>
                                </div>
                            </div>
                        </div>
                        <div class="py-2 px-3 mb-1">
                            <div className=" mt-4">
                                <button type="submit" className="main-button btn btn-success btn-sm border" onClick={this.getBalanceReport} >Filter Date <i class={isGetting ? "fas fa-sync fa-spin ml-2" : "icon-calendar22 ml-2"}></i></button>
                            </div>
                        </div>
                        {/* <div class="border-left-1 border-white py-2 px-3 rounded-0">
                            <div className="form-group" style={{ marginLeft: '-2em', marginTop: '2.2em' }}>
                                <button type="button" className="btn bg-theme " onClick={this.getTodayCalls}><i class="icon-history mr-2 icon-1x"></i>Today Filter</button>
                            </div>
                        </div>
                        <div class="border-left-1 border-white py-2 px-3 rounded-0">
                            <div className="form-group" style={{ marginLeft: '-2em', marginTop: '2.2em' }}>
                                <button type="button" className="btn bg-theme " onClick={this.getYesterdayCalls}><i class="icon-history mr-2 icon-1x"></i>Yesterday Filter</button>
                            </div>
                        </div> */}
                        {/* {isDownload ? <CSVLink data={this.state.downloadLink} className="btn btn-primary" filename={"my-file.csv"} ><i class="icon-file-download mr-2 icon-1x"></i> Download</CSVLink>:''} */}
                            {/* <div className="form-group" style={{ marginLeft: '-2em', marginTop: '2.2em' }}>
                                <button type="button" className="btn bg-theme " onClick={this.DownloadReport}><i class="icon-file-plus mr-2 icon-1x"></i>Generate Report</button>
                            </div> */}
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header border-0">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                            <input type="search" className="" placeholder="Type to filter..." value={this.state.searchValue} onChange={this.searchSpace} aria-controls="DataTables_Table_0" />
                        </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll " style={{ overflowX: 'auto' }}>
                            <table className="table-style table table-striped  dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader table-heading-style ">
                                        <th className="">Account Name</th>
                                        <th>Cost</th>
                                        <th>Minutes</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.renderReportBalance()}
                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer mt-1">
                            <div className="mt-3">
                                {/* <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={itemsCount}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange.bind(this)}
                    /> */}
                            </div>

                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div>
                    </div>
                </div>
            </Container>
        )
    }
}
export default MainReport